<template>
  <!-- 弹窗包裹新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增手环'"
    v-model:visible="open"
    @cancel="onClose"
    :width="1100"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单主体：所有手环字段均绑定 form 数据 -->
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ flex: '1 1 auto' }" class="two-column-form">
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- MAC 编码：唯一标识 -->
          <a-form-model-item label="MAC码" prop="mac">
            <a-input v-model:value="form.mac" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 岗位名称：展示给用户 -->
          <a-form-model-item label="岗位名称" prop="name">
            <a-input v-model:value="form.name" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 岗位描述：描述佩戴场景 -->
          <a-form-model-item label="手环岗位描述" prop="description">
            <a-input
              v-model:value="form.description"
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 手环类型：字典 wristband_type -->
          <a-form-model-item label="手环类型" prop="type">
            <a-select
              v-model:value="form.type"
              placeholder="请选择"
              allow-clear
              @change="handleTypeChange"
            >
              <a-select-option
                v-for="dict in dict.type['wristband_type']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 手环状态：字典 wristband_status -->
          <a-form-model-item label="手环状态" prop="wristbandStatus">
            <a-select
              v-model:value="form.wristbandStatus"
              placeholder="请选择"
              allow-clear
            >
              <a-select-option
                v-for="dict in dict.type['wristband_status']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 生产厂家 -->
          <a-form-model-item label="生产厂家" prop="manufactor">
            <a-input v-model:value="form.manufactor" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12" v-if="!isLocationWristband">
        <a-col :span="12">
          <!-- 手环佩戴类型：字典 type_of_wristband -->
          <a-form-model-item
            label="手环佩戴类型"
            prop="wearType"
          >
            <a-select
              v-model:value="form.wearType"
              placeholder="请选择"
              allow-clear
              @change="handleWearTypeChange"
            >
              <a-select-option
                v-for="dict in dict.type['type_of_wristband']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 佩戴人：选择项目人员 -->
          <a-form-model-item
            label="佩戴人"
            prop="userId"
          >
            <a-select
              v-model:value="form.userId"
              show-search
              allow-clear
              :filter-option="filterWearerOption"
              placeholder="请选择"
            >
              <template v-slot:notFoundContent>
                <a-spin size="small" v-if="wearerLoading" />
              </template>
              <a-select-option
                v-for="user in wearerOptions"
                :key="user.id"
                :value="user.id"
              >
                <span class="option-name">{{ user.nickName || '未命名' }}</span>
                <span class="option-desc" v-if="user.phoneNumber"
                  >（{{ user.phoneNumber }}）</span
                >
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12" v-if="isLocationWristband">
        <a-col :span="12">
          <!-- 定位安装设备：下拉选择（仅定位环显示且必填） -->
          <a-form-model-item
            label="定位安装设备"
            prop="equipmentId"
          >
            <a-select
              v-model:value="form.equipmentId"
              show-search
              allow-clear
              :filter-option="filterEquipmentOption"
              placeholder="请选择"
              :loading="equipmentLoading"
            >
              <template v-slot:notFoundContent>
                <a-spin size="small" v-if="equipmentLoading" />
              </template>
              <a-select-option
                v-for="equipment in equipmentOptions"
                :key="equipment.id"
                :value="equipment.id"
              >
                <span class="option-name">{{ equipment.name || '未命名' }}</span>
                <span class="option-desc" v-if="equipment.equipmentCode"
                  >（{{ equipment.equipmentCode }}）</span
                >
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 绑定时间：datetime -->
          <a-form-model-item label="绑定时间" prop="bindTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.bindTime"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 工作流类型：字典 workflow_type -->
          <a-form-model-item label="工作流类型" prop="workflowType">
            <a-select
              v-model:value="form.workflowType"
              placeholder="请选择"
              allow-clear
            >
              <a-select-option
                v-for="dict in dict.type['workflow_type']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 工作流 CODE -->
          <a-form-model-item label="工作流CODE" prop="workflowCode">
            <a-input
              v-model:value="form.workflowCode"
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 工作流名称 -->
          <a-form-model-item label="工作流名称" prop="workflowName">
            <a-input
              v-model:value="form.workflowName"
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 工作流描述 -->
          <a-form-model-item label="工作流描述" prop="workflowDescription">
            <a-input
              v-model:value="form.workflowDescription"
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 工作流是否启用：字典 workflow_status -->
          <a-form-model-item label="工作流是否启动" prop="workflowStatus">
            <a-select
              v-model:value="form.workflowStatus"
              placeholder="请选择"
              allow-clear
            >
              <a-select-option
                v-for="dict in dict.type['workflow_status']"
                :key="Number(dict.value)"
                :value="Number(dict.value)"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 是否通知：字典 is_notice -->
          <a-form-model-item label="是否通知" prop="isNotice">
            <a-select
              v-model:value="form.isNotice"
              placeholder="请选择"
              allow-clear
            >
              <a-select-option
                v-for="dict in dict.type['is_notice']"
                :key="dict.value"
                :value="dict.value"
              >
                {{ dict.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
        </a-col>
      </a-row>

      <!-- 底部操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import {
  getWristband,
  addWristband,
  updateWristband,
} from '@/api/system/wristband'
import { listProjectUserOptions } from '@/api/system/user'
import { listEquipment } from '@/api/system/equipment'

export default {
  name: 'CreateForm',
  // 需要使用的字典
  dicts: [
    'wristband_type',
    'wristband_status',
    'workflow_type',
    'workflow_status',
    'type_of_wristband',
    'is_notice',
  ],
  data() {
    return {
      submitLoading: false, // 提交按钮 loading
      formTitle: '', // 抽屉标题
      wearerOptions: [], // 佩戴人选项
      wearerLoading: false, // 佩戴人加载态
      equipmentOptions: [], // 设备选项
      equipmentLoading: false, // 设备加载态
      // 表单参数，仅保留页面展示及提交所需字段
      form: {
        id: null,
        mac: null,
        name: null,
        description: null,
        type: null,
        wristbandStatus: null,
        manufactor: null,
        userId: null,
        equipmentId: null,
        bindTime: null,
        wearType: null,
        projectId: null,
        workflowType: null,
        workflowCode: null,
        workflowName: null,
        workflowDescription: null,
        workflowStatus: null,
        isNotice: null, // 是否通知
      },
      open: false, // 抽屉显隐
    }
  },
  computed: {
    /**
     * 判断当前选择的手环类型是否为"定位环"
     * @returns {Boolean} 是否为定位环
     */
    isLocationWristband() {
      if (!this.form.type || !this.dict.type['wristband_type']) {
        return false
      }
      // 查找字典中 label 为"定位环"的项
      const locationWristband = this.dict.type['wristband_type'].find(
        (dict) => dict.label === '定位环'
      )
      if (!locationWristband) {
        return false
      }
      // 判断当前选择的 type 值是否等于定位环的值
      return String(this.form.type) === String(locationWristband.value)
    },
    /**
     * 动态表单校验规则
     * 根据手环类型动态设置验证规则
     */
    rules() {
      const baseRules = {
        mac: [{ required: true, message: 'MAC不能为空', trigger: 'blur' }],
        name: [
          { required: true, message: '岗位名称不能为空', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '手环类型不能为空', trigger: 'change' },
        ],
        workflowType: [
          { required: true, message: '工作流类型不能为空', trigger: 'change' },
        ],
        wearType: [
          { required: true, message: '手环佩戴类型不能为空', trigger: 'change' },
        ]
      }
      // 如果是定位环，则定位安装设备必填
      if (this.isLocationWristband) {
        baseRules.equipmentId = [
          {
            required: true,
            message: '定位安装设备不能为空',
            trigger: 'change',
          },
        ]
      }
      return baseRules
    },
  },
  methods: {
    /**
     * 关闭抽屉
     */
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    /**
     * 取消按钮：关闭并重置
     */
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    /**
     * 表单重置：恢复默认值
     */
    reset() {
      this.form = {
        id: null, // 主键
        mac: null, // MAC码
        name: null, // 岗位名称
        description: null, // 岗位描述
        type: null, // 手环类型
        wristbandStatus: null, // 手环状态
        manufactor: null, // 生产厂家
        userId: null, // 佩戴人
        equipmentId: null, // 定位安装设备
        bindTime: null, // 绑定时间
        wearType: null, // 手环佩戴类型
        projectId: null, // 所属项目
        workflowType: null, // 工作流类型
        workflowCode: null, // 工作流CODE
        workflowName: null, // 工作流名称
        workflowDescription: null, // 工作流描述
        workflowStatus: null, // 工作流是否启用
        isNotice: null, // 是否通知
      }
      this.wearerOptions = []
      this.equipmentOptions = []
    },
    /**
     * 新增：带入项目ID并打开抽屉
     */
    handleAdd() {
      this.reset()
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.form.projectId = currentProjectId
      }
      this.open = true
      this.formTitle = '添加'
      // 新增时，如果默认是定位环，则加载设备列表（使用vuex的项目ID）
      if (!this.isLocationWristband) {
        this.fetchWearerOptions()
      } else {
        // 新增时使用vuex的项目ID查询设备
        this.fetchEquipmentOptions()
      }
    },
    /**
     * 修改：根据 ID 查询详情
     */
    handleUpdate(row, ids) {
      this.reset()
      const id = row ? row.id : ids
      getWristband({ id }).then((response) => {
        const data = response.data || {}
        this.form = Object.assign({}, this.form, {
          ...data,
          type:
            data.type !== undefined && data.type !== null
              ? String(data.type)
              : null,
          wristbandStatus:
            data.wristbandStatus !== undefined && data.wristbandStatus !== null
              ? String(data.wristbandStatus)
              : null,
          workflowType:
            data.workflowType !== undefined && data.workflowType !== null
              ? String(data.workflowType)
              : null,
          workflowStatus:
            data.workflowStatus !== undefined && data.workflowStatus !== null
              ? Number(data.workflowStatus)
              : null,
          isNotice:
            data.isNotice !== undefined && data.isNotice !== null
              ? String(data.isNotice)
              : null,
        })
        // 编辑时，根据详情中的项目ID查询设备
        if (!this.isLocationWristband) {
          this.fetchWearerOptions()
          this.equipmentOptions = []
        } else {
          this.wearerOptions = []
          // 编辑时使用详情中的项目ID查询设备
          this.fetchEquipmentOptions()
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /**
     * 手环类型变化时的处理
     * 如果切换为定位环，清空手环佩戴类型和佩戴人字段
     * 如果切换为非定位环，清空定位安装设备字段
     */
    handleTypeChange(value) {
      if (this.isLocationWristband) {
        // 如果选择的是定位环，清空相关字段
        this.form.wearType = null
        this.form.userId = null
      } else {
        // 如果选择的是非定位环，清空定位安装设备字段
        this.form.equipmentId = null
      }
      // 清除该字段的验证状态
      if (this.$refs.form) {
        this.$refs.form.clearValidate(['equipmentId', 'wearType', 'userId'])
      }
      if (this.isLocationWristband) {
        this.wearerOptions = []
        this.fetchEquipmentOptions()
      } else {
        this.fetchWearerOptions()
        this.equipmentOptions = []
      }
    },
    /**
     * 手环佩戴类型变化时的处理
     * 当佩戴类型改变时，重新获取佩戴人选项并清空当前选中的佩戴人
     */
    handleWearTypeChange(value) {
      // 清空当前选中的佩戴人
      this.form.userId = null
      // 清除验证状态
      if (this.$refs.form) {
        this.$refs.form.clearValidate(['userId'])
      }
      // 重新获取佩戴人选项
      this.fetchWearerOptions()
    },
    /**
     * 获取佩戴人选项
     */
    fetchWearerOptions() {
      if (this.isLocationWristband) {
        this.wearerOptions = []
        return
      }
      const projectId =
        this.form.projectId || this.$store.getters.currentProjectId
      if (!projectId) {
        this.wearerOptions = []
        return
      }
      this.wearerLoading = true
      listProjectUserOptions({
        projectId,
        wearType: this.form.wearType,
      })
        .then((res) => {
          const list = res && res.data ? res.data : []
          this.wearerOptions = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.wearerOptions = []
        })
        .finally(() => {
          this.wearerLoading = false
        })
    },
    /**
     * 本地过滤佩戴人选项
     */
    filterWearerOption(input, option) {
      if (
        !option ||
        !option.componentOptions ||
        !option.componentOptions.children
      ) {
        return false
      }
      const text = option.componentOptions.children
        .map((child) => child.text || (child.elm && child.elm.innerText) || '')
        .join('')
        .toLowerCase()
      return text.includes((input || '').toLowerCase())
    },
    /**
     * 获取设备选项
     * 新增时：使用vuex的项目ID
     * 编辑时：使用详情中的项目ID（form.projectId）
     */
    fetchEquipmentOptions() {
      if (!this.isLocationWristband) {
        this.equipmentOptions = []
        return
      }
      // 优先使用form中的projectId（编辑时从详情获取），如果没有则使用vuex的项目ID（新增时）
      const projectId =
        this.form.projectId || this.$store.getters.currentProjectId
      if (!projectId) {
        this.equipmentOptions = []
        return
      }
      this.equipmentLoading = true
      listEquipment({
        projectId: projectId,
      })
        .then((res) => {
          const list = res && res.data ? res.data : []
          this.equipmentOptions = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.equipmentOptions = []
        })
        .finally(() => {
          this.equipmentLoading = false
        })
    },
    /**
     * 本地过滤设备选项
     */
    filterEquipmentOption(input, option) {
      if (
        !option ||
        !option.componentOptions ||
        !option.componentOptions.children
      ) {
        return false
      }
      const text = option.componentOptions.children
        .map((child) => child.text || (child.elm && child.elm.innerText) || '')
        .join('')
        .toLowerCase()
      return text.includes((input || '').toLowerCase())
    },
    /**
     * 提交：区分新增/修改
     */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateWristband(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addWristband(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
.create-form-modal :deep(.ant-modal-body) {
  max-height: 75vh;
  overflow-y: auto;
  padding: 20px 24px 20px 24px !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.create-form-modal :deep(.ant-form-item) {
  margin-bottom: 16px;
}

.create-form-modal :deep(.ant-form-item:last-of-type) {
  margin-bottom: 24px;
}

.create-form-modal :deep(.ant-form-item-label) {
  padding-bottom: 6px;
  flex: 0 0 150px !important;
  max-width: 150px !important;
}

.two-column-form :deep(.ant-form-item-label) {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
  text-align: right;
  padding-right: 8px !important;
  flex: 0 0 150px !important;
}

.two-column-form :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.5 !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 13px !important;
  letter-spacing: -0.2px;
}

.two-column-form :deep(.ant-form-item-control) {
  flex: 1;
  min-width: 0;
}

.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-select),
.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-tree-select) {
  width: 100%;
  min-width: 180px;
}

.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
  border-radius: 4px !important;
}

.save-btn:focus {
  border-radius: 4px !important;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:focus {
  border-radius: 4px !important;
}

.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-input:hover),
.two-column-form :deep(.ant-input:focus),
.create-form-modal :deep(.ant-input),
.create-form-modal :deep(.ant-input:hover),
.create-form-modal :deep(.ant-input:focus) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-select-selector),
.two-column-form :deep(.ant-select-selector:hover),
.two-column-form :deep(.ant-select-focused .ant-select-selector),
.create-form-modal :deep(.ant-select-selector),
.create-form-modal :deep(.ant-select-selector:hover),
.create-form-modal :deep(.ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-picker:hover),
.two-column-form :deep(.ant-picker-focused),
.create-form-modal :deep(.ant-picker),
.create-form-modal :deep(.ant-picker:hover),
.create-form-modal :deep(.ant-picker-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

.create-form-modal :deep(.ant-form) {
  padding: 0 12px !important;
}

.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 24px 50px 24px !important;
}
</style>
